class RecommendedProducts extends HTMLElement {
	constructor() {
		super();
		this.maxRecommended =
			this.dataset.maxReco || this.dataset.desktopSlide * 2 || 10;
		if (this.dataset.slider) {
			this.loadSlider();
		}
	}
	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);
			this.init();
		};
		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: "0px 0px 400px 0px",
		}).observe(this);
	}

	async init() {
		const productsIds = this.getProductsIds();
		let addClass = false;
		if (productsIds && productsIds.length > 0) {
			const responses = await this.getResults(productsIds);
			addClass = true;
			if (responses.length > 0) {
				const limit = Math.round(
					this.maxRecommended / productsIds.length
				);
				this.parentElement
					.querySelector(".swiper-wrapper.fallback-collection")
					?.remove();
				for (let i = 0; i < limit; i++) {
					responses.forEach((response) => {
						var inserted = false;
						while (!inserted) {
                            const element = response[i];
							if (element) {
								const prodId = parseInt(
									element?.querySelector("[data-product-id]")
										?.dataset.productId
								);
								if (prodId && !productsIds.includes(prodId)) {
									this.appendChild(element.cloneNode(true));
									productsIds.push(prodId);
									inserted = true;
								} else {
									response[i].parentNode.removeChild(
										response[i]
									);
								}
							} else {
								inserted = true;
							}
						}
					});
				}
			}
		} else {
			this.remove();
		}
		if (this.dataset.slider) {
			this.loadSlider(addClass);
		}
	}

	getProductsIds() {
		const productData = JSON.parse(
			localStorage.getItem("recentlyViewedProduct")
		);
		if (productData) {
			const products = productData.reverse().slice(0, 5);
			const productsIds = products.map((product) => parseInt(product.id));
			return productsIds;
		}
		return false;
	}

	async getResults(ids) {
		const responses = [];
		for (let id of ids) {
			var url = this.dataset.url.replace("[product_id]", id);
			const response = await this.getRecommendations(url);
			responses.push(response);
		}
		return responses;
	}

	getRecommendations(url) {
		return fetch(url)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement("div");
				html.innerHTML = text;
				const recommendations = html.querySelector(this.tagName);

				if (
					recommendations &&
					recommendations.innerHTML.trim().length
				) {
					return recommendations.children;
				}
			})
			.catch((e) => {
				console.error(e);
			});
	}

	loadSlider(addClass = false) {
		addClass && this.classList.add('swiper-wrapper');
		this.initSlider();
	}

	initSlider() {
		this.slider = new Swiper(
			`.section-${this.dataset.section} .swiper_container`,
			{
				slidesPerView: this.dataset.moblieSlide,
				grabCursor: true,
				preloadImages: false,
				spaceBetween: 20,
				lazy: true,
				lazy: {
					loadPrevNext: true,
				},
				mousewheel: {
					forceToAxis: true,
				},
				navigation: {
					nextEl: `.section-${this.dataset.section} .swiper-button-next`,
					prevEl: `.section-${this.dataset.section} .swiper-button-prev`,
				},
				breakpoints: {
					768: {
						spaceBetween: 15,
						slidesPerView: this.dataset.desktopSlide,
					},
				},
			}
		);
	}
}

customElements.define("recommended-products", RecommendedProducts);

class ProductRecommendations extends HTMLElement {
	constructor() {
	  super();
	}
  
	connectedCallback() {
	  const handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;
		observer.unobserve(this);
  
		fetch(this.dataset.url)
		  .then(response => response.text())
		  .then(text => {
			const html = document.createElement('div');
			html.innerHTML = text;
			const recommendations = html.querySelector('product-recommendations');
  
			if (recommendations && recommendations.innerHTML.trim().length) {
			  this.innerHTML = recommendations.innerHTML;
			}
  
			if (html.querySelector('.grid__item')) {
			  this.classList.add('product-recommendations--loaded');
			}
			if (typeof Swiper === "function") { 
			  this.initSlider(this);
			} else {
			  const _this = this;
			  document.addEventListener("swiper-loaded", function(event) {
				_this.initSlider(_this);
			  });
			  
			}
		  })
		  .catch(e => {
			console.error(e);
		  });
	  }
  
	  new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
	}
  
	initSlider(self) {
	  new Swiper(`.section-${self.dataset.section} .product-recommendations_slides_container`, {
		slidesPerView: self.dataset.mobileSlide,
		grabCursor: true,
		spaceBetween: 15,
		mousewheel: {
			forceToAxis: true,
		},
		navigation: {
		  nextEl: `.section-${self.dataset.section} .swiper-button-next`,
		  prevEl: `.section-${self.dataset.section} .swiper-button-prev`,
		},
		breakpoints: {
		  768: {
			slidesPerView: self.dataset.desktopSlide,
			spaceBetween: 20,
		  }
		}
	});
  
	}
  
  }
  
  customElements.define('product-recommendations', ProductRecommendations);